<template>
    <!-- 下面使用ref 和 $refs 来获取dom元素 -->
    <div id="main" ref="main"></div>
</template>

<script>import * as echarts from 'echarts';
import 'echarts-gl';
export default {

    name: 'BaseEarth',
    mounted() {
        // 使用this.$refs.属性名 来获取dom元素
        var chartDom = this.$refs.main;
        var myChart = echarts.init(chartDom);
        var option;

        option = {
            backgroundColor: '#000',
            globe: {
                baseTexture: require('@/assets/地球/earth.png'),
                heightTexture: require('@/assets/地球/bathymetry_bw_composite_4k.png'),
                displacementScale: 0.1,
                shading: 'lambert',
                environment: require('@/assets/地球/starfield.png'),
                light: {
                    ambient: {
                        intensity: 0.1
                    },
                    main: {
                        intensity: 1.5
                    }
                },
                layers: [
                    {
                        type: 'blend',
                        blendTo: 'emission',
                        texture: require('@/assets/地球/night.png')
                    },
                    {
                        type: 'overlay',
                        texture: require('@/assets/地球/clouds.png'),
                        shading: 'lambert',
                        distance: 5
                    }
                ]
            },
            series: []
        };

        option && myChart.setOption(option);

    }
}
</script>

<style scoped>
#main {
    margin: 0 auto;
    width: 30rem;
    height: 30rem;
}
</style>